import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useElements, useStripe } from "@stripe/react-stripe-js";
import { Formik } from "formik";
import React, { useState } from "react";
import { ErrorMessage, StripeInputElement } from "@components/atoms";
import * as S from "./styles";

/**
 * Stripe credit card form.
 */
var StripeCreditCardForm = function StripeCreditCardForm(_ref) {
  var formRef = _ref.formRef,
      formId = _ref.formId,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      onSubmit = _ref.onSubmit;
  var stripe = useStripe();
  var elements = useElements();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      stripeErrors = _useState2[0],
      setStripeErrors = _useState2[1];

  var allErrors = [].concat(_toConsumableArray(errors), _toConsumableArray(stripeErrors));
  return React.createElement(Formik, {
    initialValues: null,
    onSubmit: /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values, _ref2) {
        var setSubmitting;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setSubmitting = _ref2.setSubmitting;
                _context.next = 3;
                return onSubmit(stripe, elements);

              case 3:
                setSubmitting(false);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }()
  }, function (_ref4) {
    var handleChange = _ref4.handleChange,
        handleSubmit = _ref4.handleSubmit,
        handleBlur = _ref4.handleBlur,
        values = _ref4.values,
        isSubmitting = _ref4.isSubmitting,
        isValid = _ref4.isValid;
    return React.createElement(S.Form, {
      id: formId,
      ref: formRef,
      onSubmit: handleSubmit
    }, React.createElement(S.Card, {
      "data-test": "stripeForm"
    }, React.createElement(S.CardNumberField, null, React.createElement(StripeInputElement, {
      type: "CardNumber",
      label: "Card number",
      onChange: function onChange(event) {
        handleChange(event);
        setStripeErrors([]);
      }
    })), React.createElement(S.CardExpiryField, null, React.createElement(StripeInputElement, {
      type: "CardExpiry",
      label: "Expiration date",
      onChange: function onChange(event) {
        handleChange(event);
        setStripeErrors([]);
      }
    })), React.createElement(S.CardCvcField, null, React.createElement(StripeInputElement, {
      type: "CardCvc",
      label: "CVC",
      onChange: function onChange(event) {
        handleChange(event);
        setStripeErrors([]);
      }
    }))), React.createElement(ErrorMessage, {
      errors: allErrors
    }));
  });
};

export { StripeCreditCardForm };